//
// Action Types
//
export const SET_SIDENAV_STATE = 'web-gallery/layout/SET_SIDENAV_STATE';
export const SET_BREADCRUMB_NAVIGATION_STATE =
  'web-gallery/layout/SET_BREADCRUMB_NAVIGATION_STATE';

//
// Action Creators
//

export const setSideNavState = expanded => ({
  type: SET_SIDENAV_STATE,
  expanded,
});

export const setBreadcrumbNavigationState = enabled => ({
  type: SET_BREADCRUMB_NAVIGATION_STATE,
  enabled,
});

//
// Thunks
//
export const sideNavToggle = () => (dispatch, getState) => {
  const { sideNavExpanded } = getState().galleries.layout;

  if (sideNavExpanded) {
    dispatch(setSideNavState(false));
  } else {
    dispatch(setSideNavState(true));
  }
};
